import request from '@/utils/request'

export function getIndex(query) {
  return request({
    url: '/index/articles/index',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}
